<template>
	<div class="opera-cateringOrder">
    <topNav :title="$t('cateringOrder_title')"></topNav>
		<div class="ordertop">
				<div class="search">
						<i class="iconfont icon-sousuo"></i>
						<input type="text" id='seachContent' v-model='searchOption.searchText'   name=""   :placeholder="$t('cateringOrder_search_placeholder')">
						<div class="cleartext" @click="searchOption.searchText='';getcateringList();" v-show="searchOption.searchText != ''">
							<i class="iconfont icon-cuowu"></i>
						</div>
				</div>
				<div class="searchBtn" @click="getcateringList">{{$t('search')}}</div>
                <span class="line"></span>
                <mt-button @click.native="popupVisible3 = true"><div class="fliter">{{$t('fliter')}}<i class="iconfont icon-xia"></i></div></mt-button>
		</div>
		<div class="orderList">
			<div class="tags clearfix"  >
				<div style="width: 3000px">
					<div class="tag" @click="getList('')" :class="{active:searchOption.pccode==''}"> {{$t('all')}} </div>
					<div class="tag" @click="getList(tab.code,index)" :class="{active:searchOption.pccode==tab.code}" v-for='(tab,index) in tabList' >
						{{tab.name}}
					</div>
				</div>
			</div>
			<ul class="list clearfix" >
				<li class="item" v-for="(order,index) in orderList" :key="order.accnt">

					<div class="detailed">
						<div class="top clearfix"><p class="left">{{$t('cateringOrder_accnt')}}：{{order.accnt}}</p><p class="right" style="color:#FF6363">{{sta[order.sta]}}</p> </div>
					<router-link :to="'/opera/cateringDetail?id='+order.accnt">
						<div class="content clearfix" >
							<ul>
								<li class="info">
                  {{$t('cateringOrder_linkMan')}}: {{order.linkMan}}
								</li>
								<li class="info">
                  {{$t('cateringOrder_resName')}}:{{order.resName}}
								</li>
								<li class="info">
                  {{$t('cateringOrder_tablenoDes')}}: {{order.tablenoDes}}
								</li>
								<li class="info">
                  {{$t('cateringOrder_phone')}}:<a :href='"tel:"+order.phone'>{{order.phone}}</a>
								</li>
								<li class="info">
                  {{$t('cateringOrder_gsts')}}: {{order.gsts}}
								</li>
								<li class="info">
                  {{$t('cateringOrder_bizDate')}}:{{order.bizDate | dateF}}  {{order.shiftDes}}
								</li>
							</ul>
							<i class="iconfont icon-you"></i>
						</div>
					 </router-link>
					</div>
				</li>
                <nothing :condition="orderList != null && (orderList.length == undefined || orderList.length == 0)"></nothing>
			</ul>
		</div>
	<mt-popup v-model="popupVisible3" position="right" class="mint-popup-3 rightFliterBox" :modal="true">
		<div class="rightFliterBox">
			<div class="filter_title"><span class="title">{{$t('fliter')}}</span>
			<mt-button @click.native="popupVisible3 = false" ><i class="iconfont icon-cuowu" ></i></mt-button> </div>

            <div class="fliter_item">
				<div class="category_name"><span>{{$t('cateringOrder_shift')}}</span></div>
				<div class="category_list clearfix twocol">
					<div v-for='(value,key) in shift' :key="key">
						<div class="option oplist" :class='{checked:key==searchOption.shift}'  @click='selectSelf("shift",key)'>{{value}}</div>
					</div>
				</div>
			</div>
            <div class="fliter_item">
				<div class="category_name"><span>{{$t('cateringOrder_pccode')}}</span></div>
				<div class="category_list clearfix twocol">
					<div v-for='tab in tabList' :key="tab.code">
						<div class="option oplist" :class='{checked:tab.code==searchOption.pccode}'  @click='selectSelf("pccode",tab.code)'>{{tab.name}}</div>
					</div>
				</div>
			</div>
            <div class="fliter_item">
				<div class="category_name"><span>{{$t('cateringOrder_beginDate')}}</span></div>
				<div class="category_list clearfix ">
                        <div class="option oplist" style="width:3rem" @click="openPick('picker')">{{searchOption.beginDate | fdate}}</div>
<div class="option oplist clearfix" @click="searchOption.endDate=searchOption.beginDate" style="width:1.5rem">{{$t('eventWorm_today')}}</div>
				</div>
			</div>
                   <div class="fliter_item">
				<div class="category_name"><span>{{$t('cateringOrder_endDate')}}</span></div>
				<div class="category_list clearfix ">
                        <div class="option oplist" style="width:3rem" @click="openPick('picker2')">{{searchOption.endDate | fdate}}</div>

				</div>
			</div>
			<div class="bottom_f">
        <div class="reset"
             @click='reset'> {{$t('reset')}}
        </div>
        <div class="success"
             @click='sendData'> {{$t('complete')}}
        </div>
			</div>
		</div>
	</mt-popup>
     <mt-datetime-picker ref="picker" type="date" @confirm="handleConfirm" :startDate="minDate" :endDate="maxDate" v-model="searchOption.beginDate"></mt-datetime-picker>
    <mt-datetime-picker ref="picker2" type="date" :startDate="minDate2" :endDate="maxDate" v-model="searchOption.endDate"></mt-datetime-picker>
	</div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import nothing from "../operaCommon/nothing";
import { Toast } from 'mint-ui';
export default {
  data() {
    return {
      tabList: [],
      orderList: null,
      searchOption: {
        searchText: "",
        pccode: "",
        shift:"",
        beginDate:moment().format("YYYY-MM-DD"),
        endDate:moment().add(1,"M").format("YYYY-MM-DD")
      },
      minDate: moment(moment().format("YYYY-MM-DD")).toDate(),
      minDate2: moment(moment().format("YYYY-MM-DD")).toDate(),
      maxDate: moment(moment().add(1, "M").format("YYYY-MM-DD")).toDate(),
      shift: {
        1: this.$t('cateringOrder_shift_1'),
        2: this.$t('cateringOrder_shift_2'),
        3: this.$t('cateringOrder_shift_3'),
        4: this.$t('cateringOrder_shift_4'),
      },
      sta: {
        R: this.$t('cateringOrder_shift_R'),
        N: this.$t('cateringOrder_shift_N'),
        C: this.$t('cateringOrder_shift_C'),
        I: this.$t('cateringOrder_shift_I'),
        X: this.$t('cateringOrder_shift_X'),
      },
      popupVisible3: false
    };
  },
  mounted() {
    /*获取餐厅列表*/
    this.$http.get("/mobilepmsapi/reception/getPosPcCode").then(res => {
      if (res.data.result == 0) {
        this.tabList = res.data.retVal;
      }
    });
    this.getcateringList();
  },
  methods: {
    /*获取列表信息*/
    getcateringList() {
      this.$http
        .post("/mobilepmsapi/reception/getPosResList", this.searchOption)
        .then(res => {
          if (res.data.result == 0) {
            this.orderList = res.data.retVal;
          }
          else{
            this.msg(res.data.msg);
          }
        });
    },
     msg(msg) {
            Toast({
                message: msg,
                position: 'bottom',
                duration: 3000
            });
        },
    setInfo(item) {},
     selectSelf(node,v) {
      if (this.searchOption[node]== v) {
        this.searchOption[node] = "";
      } else {
        this.searchOption[node] = v;
      }
    },
    openPick(p) {
      this.$refs[p].open();
    },
    handleConfirm(d) {
      this.minDate2 = moment(this.searchOption.beginDate).toDate();
      if (moment(this.searchOption.endDate) < moment(this.searchOption.beginDate)) {
        this.searchOption.endDate = moment(this.searchOption.beginDate).format("YYYY-MM-DD");
      }
    },
    reset() {
        this.searchOption.shift = "";
        this.searchOption.pccode="";
        this.searchOption.searchText = "";
        this.searchOption.beginDate = moment().format("YYYY-MM-DD");
        this.searchOption.endDate = moment().add(1,"M").format("YYYY-MM-DD");
    },
    sendData() {
      this.popupVisible3 = false;
      this.getcateringList();
    },
    //点击事件，导航点中的标题居中
    getList(value,index) {
             this.searchOption.pccode = value;
              var numberIndex = index;
             if(numberIndex<2||this.searchOption.pccode==''){
                 document.getElementsByClassName('tags')[0].scrollLeft=0;
             }else if(numberIndex<this.tabList.length-3){
                   document.getElementsByClassName('tags')[0].scrollLeft=(numberIndex-1)*80;
              }
              if(numberIndex==this.tabList.length-3){
                  document.getElementsByClassName('tags')[0].scrollLeft=(numberIndex-1)*80+40;
              }
              this.getcateringList();
    },
  },
  filters: {
    dateF(value) {
      return value != "" ? value.replace(/-/g, "/").substring(5, 10) : "";
    },
    fdate(value) {
      return moment(value).format("YYYY-MM-DD");
    }
  },
  components: {
    nothing
  }
};
</script>
<style lang='less' scoped>
.opera-cateringOrder {
  background: #f7f8fa;
  height: auto;
  .ordertop {
    height: 1.28rem;
    width: 10rem;
    background: #fff;
    padding: 0.18666667rem 0;
    box-sizing: border-box;
    position: absolute;
    z-index:2000;
    .line {
      float: left;
      width: 0.02666667rem;
      height: 0.53333333rem;
      background-color: #ccc;
      margin-top: 0.21333333rem;
    }
    .searct_btn {
      width: 1.73333333rem;
      box-sizing: border-box;
      text-align: left;
      float: left;
      height: 100%;
      font-size: 0.32rem;
      line-height: 0.89333333rem;
      color: #5b5b5b;
      padding-left: 0.33333333rem;
    }
    .mint-button {
      height: 100%;
      background: #fff;
      box-shadow: none;
      padding: 0;
      .fliter {
        width: 1.86666667rem;
        float: left;
        font-size: 0.32rem;
        line-height: 0.89333333rem;
        text-align: right;
        box-sizing: border-box;
        color: #5b5b5b;
        .iconfont {
          display: inline-block;
          margin-left: 0.13333333rem;
        }
      }
    }
    .search {
      margin-left: 0.34666667rem;
      border-radius: 0.44rem;
      width: 5.8rem;
      float: left;
      height: 0.85333333rem;
      background-color: #f7f8fa;
      padding: 0 0.26666667rem;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      i.icon-sousuo {
        vertical-align: bottom;
        font-size: 0.42666667rem;
        color: #ccc;
        line-height: 0.89333333rem;
      }
      input {
        padding-left: 0.2rem;
        width: 4.4rem;
        vertical-align: middle;
        //margin-bottom: 0.13333rem;
        flex: 1;
        height: 0.62666667rem;
        background-color: #f7f8fa;
        outline: 0;
        border: 0;
      }

      .cleartext {
        float: right;
        display: block;
        i.icon-cuowu {
          line-height: 0.32rem;
          background-color: #c3c3c3;
          border-radius: 50%;
          font-size: 0.32rem;
          text-align: center;
          color: #fff;
          padding: 0.13333333rem;
          margin-top: 0.13333333rem;
          -webkit-transform-origin-x: 0;
          transform: scale(0.6);
          -webkit-transform: scale(0.6);
          width: 0.32rem;
          display: inline-block;
        }
      }
    }
    .searchBtn {
      width: 1.73333333rem;
      text-align: center;
      float: left;
      line-height: 0.85333333rem;
      font-size: 0.32rem;
      color: #333333;
    }
  }
  .orderList {
    margin-top: 1.4133rem;
    padding: 0 5px;
    .tags {
      height: 34px;
      width: 100%;
      overflow-x: auto;
      background-color: #fff;
      border-bottom:5px solid #f7f8fa;
      &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
      }
      .tag {
    float: left;
    position: relative;
    width: 80px;
    height: 20px;
    text-align: center;
    font-size: 12px;
    color: #333;
    padding-top: 13px;
        &.active:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          width: 30px;
          height: 3px;
          background-color: #f69c2d;
          margin: 0 auto;
        }
      }
    }
    .list {
      height: ~"calc(100vh - 138px)";
      overflow: scroll;
      width: 100%;
      .item {
        &:first-child{
         margin-top:-12px;
        }
        .detailed {
          width: 100%;
          margin: 12px auto 0;
          line-height: 14px;
          font-size: 12px;
          background-color: #fff;
          .top {
            padding: 6px 8px;
            border-bottom: 1px dashed #ddd;
            border-top: 3px solid #d2d6de;
            .left {
              float: left;
            }
            .right {
              float: right;
              span {
                color: #d0011b;
              }
            }
          }
          .content {
            position: relative;
            .info {
              color: #333;
              float: left;
              box-sizing: border-box;
              height: 22px;
              line-height: 22px;
              font-size: 12px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space:nowrap;
              a{

              }
            }
            .info:nth-of-type(2n-1) {
              width: 50%;
              padding-left: 13px;
            }
            .info:nth-of-type(2n) {
              width: 50%;
            }
            .iconfont {
              position: absolute;
              right: 6px;
              top: ~"calc(50% - 6px)";
              color: #9b9b9b;
            }
          }
        }
      }
    }
  }
  .mint-popup-3 {
    width: 6.13333333rem;
    height: 100%;
    .rightFliterBox {
      overflow: auto;
      width: 6.13333333rem;
      height: 100%;
      box-shadow: none;
      top: 0;
      background-color: #fff;
      transition: right 0.5s ease-in-out;
      box-shadow: 0 0.02666667rem 0.4rem #464444;
      .filter_title {
        width: 100%;
        height: 1.2rem;
        .title {
          float: left;
          line-height: 1.2rem;
          font-size: 0.4rem;
          margin-left: 0.4rem;
        }
        .mint-button {
          float: right;
          height: 100%;
          background: #fff;
          box-shadow: none;
          .icon-cuowu {
            float: right;
            margin-right: 0.4rem;
            line-height: 1.2rem;
            font-size: 0.4rem;
          }
        }
      }
      .fliter_item {
        margin-top: 0.4rem;
        padding: 0 0.26666667rem;
        &:nth-last-of-type(2) .category_list {
          border-bottom: 1.33333333rem solid #fff;
          /*padding-bottom: 1.33333333rem;*/
        }
        .category_name {
          height: 0.33333333rem;
          margin: 0 0.26666667rem 0.06666667rem;
          span {
            font-size: 0.26666667rem;
            color: #9B9B9B;
          }
        }
        .category_list {
          padding: 0.26666667rem 0 0.13333333rem;
          border-bottom: 0.02666667rem solid #efefef;
          .option {
            font-size: 0.33333333rem;
            width: 1.6rem;
            margin: 0px 0.13333333rem 0.26666667rem;
            float: left;
            border-radius: 0.10666667rem;
            background-color: #efefef;
            color: #606060;
            text-align: center;
            line-height: 0.69333333rem;
            overflow: hidden;
            height: 0.69333333rem;
          }
          & .checked {
            background-color: #f98f3c;
            color: #fff;
          }
          &.twocol {
            .option {
              width: 2.53333333rem;
              color: #333333;
            }
          }
        }
      }
      .bottom_f {
        position: absolute;
        width: 6.13333333rem;
        bottom: 0;
        height: 1.2rem;
        padding: 0.26666667rem 0;
        box-sizing: border-box;
        color: #fff;
        background-color: -webkit-linear-gradient(to left, #ff5a51, #ffa500);
        background-color: -o-linear-gradient(to left, #ff5a51, #ffa500);
        background-image: linear-gradient(to left, #ff5a51, #ffa500);
        .reset {
          float: left;
          text-align: center;
          font-size: 0.42666667rem;
          line-height: 0.66666667rem;
          height: 0.66666667rem;
          width: 50%;
          box-sizing: border-box;
          border-right: 0.02666667rem solid #fff;
        }
        .success {
          float: left;
          width: 50%;
          line-height: 0.66666667rem;
          height: 0.66666667rem;
          text-align: center;
          font-size: 0.42666667rem;
        }
      }
    }
  }
}
.cateringOrder .clearfix:after{
    content:'';
}
</style>



// WEBPACK FOOTER //
// cateringOrder.vue?2d4e8ee8